import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, letting a later Tailwind utility override an earlier one
 * (`cn('px-2', 'px-4')` → `px-4`). Every component takes a `className` and
 * passes it last through this, which is what makes call-site overrides work.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
